import axios, { AxiosInstance } from 'axios';
import { getApiUrl } from '../config/configService';

let apiInstance: AxiosInstance | null = null;

const createApiInstance = async (): Promise<AxiosInstance> => {
  const baseURL = await getApiUrl();
  return axios.create({ baseURL });
};

const getApiInstance = async (): Promise<AxiosInstance> => {
  if (!apiInstance) {
    apiInstance = await createApiInstance();
  }
  return apiInstance;
};

const api = new Proxy({} as AxiosInstance, {
  get(target, prop) {
    return async (...args: any[]) => {
      const instance = await getApiInstance();
      return (instance as any)[prop](...args);
    };
  }
});

export default api;
